/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
function e(){const e=globalThis.require?.modules;if(e){const o=Object.keys(e);for(const s of o)s.includes(".glsl")&&delete e[s]}}export{e as removeLoadedShaderModules};
